<template>
  <div>
    <div class="navbar-wrapper col-lg-12 mx-auto p-0">
      <nav
        class="
          navbar navbar-expand-lg navbar-light
          align-items-center
          justify-content-between
          p-0
        "
      >
        <a class="navbar-brand" href="/">
          <img
            :src="logo.imageSource"
            :width="logo.width"
            :height="logo.height"
            :alt="logo.alternateText"
          />
        </a>
        <div class="justify-content-center d-none d-lg-flex d-xl-flex">
          <h1
            class="m-0 p-0"
            :style="`line-height: 1; font-size: 30px; color: ${color};`"
          >
            {{ title }}
          </h1>
        </div>
        <div class="align-items-center">
          <button
            v-if="showNavLinks"
            class="navbar-toggler"
            type="button"
            aria-expanded="false"
            aria-label="Toggle navigation"
            @click="openNavLinks"
          >
            <span class="navbar-toggler-icon" v-if="fields.length"></span>
          </button>
        </div>
        <ul v-if="showNavLinks" class="navbar-nav expandedDiv" ref="expandedDiv">
          <li
            class="navbarLinks"
            v-for="field in fields"
            :key="field.fieldId"
          >
            <componentRenderer v-bind:key="field.id" :field="field" />
          </li>
        </ul>
      </nav>
    </div>
    <hr v-if="showLine" class="hr" />
  </div>
</template>

<script>
import componentRenderer from "@/components/component-renderer";

export default {
  name: "navbar",
  components: { componentRenderer },
  props: {
    showLine: {
      required: false,
      type: Boolean
    },
    backgroundColor: {
      required: false,
      type: String,
      default: "#fff"
    },
    title: {
      required: false,
      type: String,
      default: "Hello world"
    },
    logo: {
      required: true,
      type: Object
    },
    fields: {
      required: false,
      type: Array,
      default: () => []
    },
    color: {
      required: false,
      type: String,
      default: "#000"
    }
  },
  computed: {
    showNavLinks() {
      return this.$store.state.showNavLinks;
    }
  },
  methods: {
    openNavLinks () {
      const expandedDiv = this.$refs["expandedDiv"];
      expandedDiv.style.maxHeight = expandedDiv.style.maxHeight
        ? null
        : expandedDiv.scrollHeight + "px";
    }
  }
};
</script>

<style lang="scss" scoped>
@media (max-width: 991px) {
  .expandedDiv {
    width: 100%;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.4s ease-out;
    -moz-transition: height 0.4s ease-out; /* Firefox 4 */
    -webkit-transition: height 0.4s ease-out; /* Safari and Chrome */
    -o-transition: height 0.4s ease-out; /* Opera */
  }
}

.navbarLinks {
  white-space: nowrap;
  justify-content: center;
  align-items: center;
  display: flex;
  padding-left: 15px;
  padding-right: 15px;

  a {
    &:hover {
      box-shadow: none !important;
      text-decoration: underline;
      text-underline-position: under;
    }
  }
}

.navbar-wrapper {
  position: relative;
}

.navbar-brand {
  padding-bottom: 0;

  img {
    width: 345.6px;
    height: 45.09px;

    @media (max-width: 992px) {
      // position: relative;
      width: 192px;
      height: 25px;
    }
  }
}

.hr {
  margin-top: 8px;
  margin-bottom: 8px;
}
.navbar-collapse {
  flex-grow: initial;
}

.navbar-toggler {
  border: 0;

  &:focus {
    outline: none;
  }
}
</style>